import React, { useState } from 'react';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  // Updated images array with 15 local images (image1.jpeg to image15.jpeg)
  const images = [
    { id: 1, src: "image1.jpeg",  },
    { id: 2, src: "image2.jpeg" },
    { id: 3, src: "image3.jpeg" },
    { id: 4, src: "image4.jpeg" },
    { id: 5, src: "image5.jpeg"},
    { id: 6, src: "image6.jpeg"},
    { id: 7, src: "image7.jpeg"},
    { id: 8, src: "image8.jpeg"},
    { id: 9, src: "image9.jpeg"},
    { id: 10, src: "image10.jpeg"},
    { id: 12, src: "image12.jpeg"},
    { id: 13, src: "image13.jpeg"},
    { id: 14, src: "image14.jpeg"},
    { id: 15, src: "image15.jpeg"}
  ];

  const categories = ["All"];
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredImages = activeCategory === "All" ? images : images.filter(img => img.category === activeCategory);

  const openModal = (img) => setSelectedImage(img);
  const closeModal = () => setSelectedImage(null);
  const nextImage = () => {
    const index = filteredImages.findIndex(img => img.id === selectedImage.id);
    if (index < filteredImages.length - 1) setSelectedImage(filteredImages[index + 1]);
  };
  const prevImage = () => {
    const index = filteredImages.findIndex(img => img.id === selectedImage.id);
    if (index > 0) setSelectedImage(filteredImages[index - 1]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50/30">
      <div className="bg-gradient-to-r from-blue-700 to-indigo-700 py-20 text-center text-white">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Gallery</h1>
        <div className="w-20 h-1 bg-yellow-400 mx-auto rounded-full mb-4"></div>
        <p className="text-lg max-w-2xl mx-auto">Moments captured at our campus</p>
      </div>

      <div className="container mx-auto px-6 py-16">
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                activeCategory === cat
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {filteredImages.map(img => (
            <div
              key={img.id}
              onClick={() => openModal(img)}
              className="group relative overflow-hidden rounded-xl shadow-md cursor-pointer"
            >
              <img
                src={img.src}
                alt={img.title}
                className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                <p className="text-white font-semibold">{img.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4" onClick={closeModal}>
          <button onClick={closeModal} className="absolute top-4 right-4 text-white text-2xl">
            <FaTimes />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-4 text-white text-3xl"
          >
            <FaChevronLeft />
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.title}
            className="max-h-[90vh] max-w-[90vw] object-contain"
          />
          <button
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-4 text-white text-3xl"
          >
            <FaChevronRight />
          </button>
        </div>
      )}
    </div>
  );
};

export default Gallery;